import { bl_fi_mst_ecomsync_item_ext_RowClass, bl_fi_mst_ecomsync_item_hdr_RowClass, bl_fi_mst_ecomsync_item_line_RowClass, bl_fi_mst_pricing_scheme_link_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class PowerSearchEcomSyncItemContainerModel extends BaseContainerModel {
  bl_fi_mst_ecomsync_item_hdr: bl_fi_mst_ecomsync_item_hdr_RowClass = new bl_fi_mst_ecomsync_item_hdr_RowClass();
  bl_fi_mst_ecomsync_item_exts: bl_fi_mst_ecomsync_item_ext_RowClass[] = [];
  bl_fi_mst_ecomsync_item_lines: bl_fi_mst_ecomsync_item_line_RowClass[] = [];
  bl_fi_mst_pricing_scheme_links: bl_fi_mst_pricing_scheme_link_RowClass[] = [];
  bl_fi_mst_pricing_scheme_2_links: bl_fi_mst_pricing_scheme_link_RowClass[] = [];
}

